import { mapGetters } from 'vuex';
import accountVerifyMixin from '@/mixins/accountVerify';
import socialLevelMixin from '@/mixins/socialLevel';
import unreadNotificationMixin from '@/mixins/unreadNotification';

export default {
  mixins: [
    accountVerifyMixin,
    socialLevelMixin,
    unreadNotificationMixin,
  ],
  props: {
    showIcons: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    classModifiers() {
      return {
        'app-bottom-nav': true,
        'app-bottom-nav--logged-in': this.isLoggedIn,
      };
    },
    enabledLinks() {
      return this.links.filter(i => i.enabled);
    },
    links() {
      if (this.isLoggedIn) {
        return [
          {
            title: 'Markets',
            name: 'markets',
            href: '/markets',
            enabled: true,
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
            enabled: true,
          },
          {
            title: 'Account',
            name: 'account',
            href: this.accountLink,
            enabled: true,
          },
        ];
      }

      return [
        {
          title: 'Markets',
          name: 'markets',
          href: '/markets',
          enabled: true,
        },
        {
          title: 'News',
          name: 'news',
          href: '/news',
          enabled: true
        },
        {
          title: 'Learn',
          name: 'help',
          href: '/support',
          enabled: true,
        },
      ];
    },
  },
  methods: {
    itemClassModifier(item) {
      return {
        'app-bottom-nav__item': true,
        'app-bottom-nav__item--active': this.$route.path.includes(item.href),
        'app-bottom-nav__item--logged-in': this.isLoggedIn,
      };
    },
    linkClassModifiers(name) {
      const routes = [
        'market-details',
      ];
      const dontHighlight = routes.includes(this.$route.name);
      return {
        [`app-bottom-nav__link-with-icon app-bottom-nav__link-with-icon--${name}`]: this.showIcons,
        'app-bottom-nav__link--no-highlight': dontHighlight,
        'app-bottom-nav__link': true,
      };
    },
    showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile &&
        item.name === 'dashboard' &&
        this.isLoggedIn;
    },
    showRegularItem(item) {
      return this.isLayoutMobile ? item.name !== 'dashboard' : true;
    },
    onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-bottom-nav/app-bottom-nav.js